<template>
  <div class="home">
    <Room artistID='lmb' loadImmediate="true"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Room from '@/components/Room';

export default {
  name: "LisaMarieBarber",
  components: {
    Room
  },

  methods : {

    init() {
      console.log('LISA MARIE')
      this.$store.commit('setArtist', this.selected);
      this.$store.commit('hide', 'gallery');
      this.$store.commit('show', 'room');
    }
  }
};
</script>
